/* Code TV (7 oct 2026) : page affichée dans le navigateur d'une télé. Génère un code de 4 caractères, l'inscrit dans Firebase
   (tv/<code>), puis attend que l'app envoie une vidéo (tv/<code>/play) ou une commande (tv/<code>/cmd : play, pause, stop).
   Aucun Liquid ici. Lecture par le lecteur Vimeo (domaine laefitness.com autorisé). */
(function () {
  'use strict';
  var ALPHA = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'; /* sans 0, O, 1, I, L : lisible sur une télé */
  var TTL = 12 * 3600 * 1000;
  var codeEl = document.getElementById('code'),
    howEl = document.getElementById('how'),
    tvEl = document.getElementById('tv'),
    playEl = document.getElementById('play'),
    goBtn = document.getElementById('go');
  var db,
    uid,
    code,
    ref,
    frame = null,
    touched = false,
    lastPlay = 0,
    lastCmd = 0;

  function gen() {
    var s = '';
    for (var i = 0; i < 4; i++) s += ALPHA.charAt(Math.floor(Math.random() * ALPHA.length));
    return s;
  }
  function claim(tries) {
    var c = gen(),
      r = db.ref('tv/' + c);
    return r.once('value').then(function (s) {
      var v = s.val();
      if (v && v.ts && v.ts > Date.now() - TTL && v.uid !== uid) {
        if (tries > 8) throw new Error('codes');
        return claim(tries + 1);
      }
      return r.set({ ts: Date.now(), uid: uid }).then(function () {
        return c;
      });
    });
  }
  function post(method, value) {
    if (!frame || !frame.contentWindow) return;
    var m = { method: method };
    if (value !== undefined) m.value = value;
    try {
      frame.contentWindow.postMessage(m, 'https://player.vimeo.com');
    } catch (e) {}
  }
  function stop() {
    if (frame) {
      frame.remove();
      frame = null;
    }
    goBtn.classList.add('hid');
    playEl.style.display = 'none';
    tvEl.style.display = '';
  }
  var seekTo = 0; /* 20 oct 2026 : position envoyée par l'app (play.s) : la TV reprend là où la fille était rendue */
  function seek() {
    if (seekTo > 0) post('setCurrentTime', seekTo);
    seekTo = 0;
  }
  function play(p) {
    if (!p || !p.e || !/^https:\/\/player\.vimeo\.com\/video\/\d+/.test(p.e)) return;
    stop();
    seekTo = typeof p.s === 'number' && p.s > 3 ? p.s : 0;
    var url =
      p.e +
      (p.e.indexOf('?') > -1 ? '&' : '?') +
      'autoplay=1&playsinline=1&badge=0&title=0&byline=0&portrait=0';
    frame = document.createElement('iframe');
    frame.src = url;
    frame.allow = 'autoplay; fullscreen; encrypted-media';
    frame.setAttribute('allowfullscreen', '');
    playEl.insertBefore(frame, goBtn);
    tvEl.style.display = 'none';
    playEl.style.display = 'block';
    document.title = (p.t ? p.t + ' · ' : '') + 'LAE Fitness';
    if (!touched) {
      /* premier lancement : le navigateur de la télé refuse souvent l'autoplay avant une action ; le bouton a le focus, OK de la télécommande suffit */
      goBtn.classList.remove('hid');
      setTimeout(function () {
        try {
          goBtn.focus();
        } catch (e) {}
      }, 100);
    } else {
      frame.addEventListener('load', function () {
        setTimeout(function () {
          seek();
          post('play');
        }, 600);
      });
    }
  }
  goBtn.addEventListener('click', function () {
    touched = true;
    goBtn.classList.add('hid');
    seek();
    post('play');
  });
  document.addEventListener('keydown', function (ev) {
    /* télécommande : OK / Entrée lance la lecture si le bouton est là ; Espace met en pause ou repart */
    if (!frame) return;
    if ((ev.key === 'Enter' || ev.key === ' ') && !goBtn.classList.contains('hid')) {
      ev.preventDefault();
      goBtn.click();
    }
  });
  function listen() {
    ref = db.ref('tv/' + code);
    ref.child('play').on('value', function (s) {
      var p = s.val();
      if (!p || !p.ts || p.ts === lastPlay) return;
      lastPlay = p.ts;
      play(p);
    });
    ref.child('cmd').on('value', function (s) {
      var c = s.val();
      if (!c || !c.ts || c.ts === lastCmd) return;
      lastCmd = c.ts;
      if (c.m === 'pause') post('pause');
      else if (c.m === 'play') post('play');
      else if (c.m === 'stop') stop();
      else if (c.m === 'seek' && typeof c.v === 'number') post('setCurrentTime', c.v);
    });
    /* garde le code vivant : la page ouverte renouvelle ts chaque heure */
    setInterval(function () {
      ref.child('ts').set(Date.now());
    }, 3600 * 1000);
  }
  function fail(msg) {
    codeEl.textContent = '· · · ·';
    howEl.textContent = msg;
  }
  try {
    firebase
      .auth()
      .signInAnonymously()
      .then(function (u) {
        uid = u.user.uid;
        db = firebase.database();
        return claim(0);
      })
      .then(function (c) {
        code = c;
        codeEl.textContent = c.split('').join(' ');
        listen();
      })
      .catch(function (e) {
        fail(
          "Impossible d'obtenir un code pour le moment. Vérifie que la télé est connectée à Internet, puis recharge la page."
        );
        try {
          console.log('lae-tv', e && e.message);
        } catch (x) {}
      });
  } catch (e) {
    fail('Ce navigateur ne peut pas ouvrir la page. Essaie avec un autre navigateur sur ta télé.');
  }
})();
